import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/system';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { t } from 'i18next';
import { Button } from '@mui/material';

export interface ErrorPageProps {
  icon?: ReactNode;
  title?: ReactNode;
  messsage?: ReactNode;
  linkTo?: string;
  navigateToLabel?: string;
}

const ErrorPage = (props: ErrorPageProps) => {
  const navigate = useNavigate();

  return (
    <Container className="error-page">
      {props.icon ?? <WarningAmberIcon />}
      {props.title ?? <h1>Uh oh...</h1>}
      {props.messsage ?? <p>{t("page-not-existing")}</p>}

      <Button onClick={() => navigate(props.linkTo ?? "/")}>
        {props.navigateToLabel ?? t("go-to-homepage")}
      </Button>
    </Container>
  );
};

export default ErrorPage;
